import { Chip, Grid, Typography, Button, Divider } from "@mui/material";
import { getFormatedDate } from "../../common/Helper";

export const ServerProductQuoteCard = ({ quote, clickCard }: any) => {
  return (
    <Grid item xs={12} sx={{ p: 2, border: "1px solid #eee", borderRadius: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={6} lg={2}>
          <Typography variant="caption">Quote</Typography>
          <Typography># {quote.id}</Typography>
        </Grid>

        <Grid item xs={6} lg={2}>
          <Typography variant="caption">Estimated</Typography>
          <Typography>LKR {quote.estimatedPrice}</Typography>
        </Grid>

        <Grid item xs={6} lg={2}>
          <Typography variant="caption">Options</Typography>
          <Typography>{quote.options.length}</Typography>
        </Grid>

        <Grid item xs={6} lg={2}>
          <Typography variant="caption">Date</Typography>
          <Typography>{getFormatedDate(quote.createdAt)}</Typography>
        </Grid>

        <Grid item xs={6} lg={2}>
          <Chip
            label={quote.status}
            color={
              quote.status === "APPROVED"
                ? "success"
                : quote.status === "REJECTED"
                  ? "error"
                  : "warning"
            }
          />
        </Grid>

        <Grid item xs={6} lg={2}>
          <Button onClick={() => clickCard(quote)}>View</Button>
        </Grid>
      </Grid>

      {quote.comments && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          {quote.comments.substring(0, 80)}...
        </Typography>
      )}

      <Divider sx={{ mt: 2 }} />
    </Grid>
  );
};
